import { ruTranslations } from '@sbercloud/common-translations';
export var ru_RU = {
  ErrorPage: {
    frontendErrorTitle: 'Непредвиденная ошибка',
    pageUnavailableTitle: 'Сервис недоступен',
    pageNotFoundTitle: 'Страница не найдена',
    refreshButton: 'Обновить страницу',
    actionRedirectTitle: 'Попробуйте начать с другой страницы',
    supportCenterButton: 'Служба поддержки',
    mainPageLink: 'На главную',
    backLink: 'Назад',
    offlineTitle: 'Нет подключения к Интернету',
    offlineText: 'Проверьте соединение с интернетом и попробуйте обновить страницу',
    redirectTitle: 'Ссылка будет удалена',
    redirectText: 'Эта ссылка устарела и скоро будет удалена. Перейдите по новой ссылке.',
    redirectButton: 'Перейти'
  },
  FieldsPredefined: {
    SelectCreate: {
      buttonCreate: 'Создать',
      buttonCancel: 'Отмена',
      buttonRefetch: 'Обновить',
      selectPlaceholder: 'Не выбрано',
      noData: 'не обнаружены',
      noResult: 'не найдены',
      loadError: 'Измените запрос или создайте',
      changeRequest: 'Не удалось загрузить'
    },
    FieldPhone: {
      russia: 'Россия',
      belarus: 'Беларусь',
      kazakhstan: 'Казахстан',
      armenia: 'Армения',
      kyrgyzstan: 'Киргизстан',
      uzbekistan: 'Узбекистан',
      azerbaijan: 'Азербайджан',
      tajikistan: 'Таджикистан',
      georgia: 'Грузия'
    }
  },
  Header: {
    headerProjectSelectorCreateProject: 'Создать проект',
    headerProjectSelectorCreateWorkspace: 'Создать workspace',
    headerProjectSelectorEditOption: 'Редактировать',
    noDataFound: 'Ничего не найдено',
    // ЛК 2.0
    menu: 'Меню',
    navigation: 'Навигация',
    searchByServices: 'Поиск по сервисам',
    noData: 'Нет данных',
    notifications: 'Уведомления',
    notificationsAll: 'Все',
    notificationsUnread: 'Новые',
    markAllAsRead: 'Отметить все как прочитанное',
    noNotificationsTitle: 'Нет уведомлений',
    noNotificationsDescription: 'Здесь вы увидите новые уведомления о событиях, когда что-то произойдет',
    notificationsErrorTitle: 'Уже чиним',
    notificationsErrorDescription: 'Скоро здесь появятся ваши уведомления',
    notificationsDivider: 'Прочитанные',
    notificationsFooterButton: 'Все события',
    search: 'Поиск',
    searchCloseButton: 'Закрыть поиск',
    searchOpenButton: 'Открыть поиск',
    edit: 'Редактировать',
    organizations: 'Организации',
    addOrganization: 'Добавить организацию',
    organizationNewBadge: 'Новая',
    partnerOrganizationBadge: 'Партнер',
    invitePopoverTitle: 'Теперь вам доступна другая организация',
    invitePopoverText: 'Сменить организацию можно нажав на профиль',
    invitePopoverAcceptButton: 'Сменить сейчас',
    invitePopoverCancelButton: 'Закрыть',
    projects: 'Проекты',
    addProject: 'Добавить проект',
    platforms: 'Платформы',
    manageProfile: 'Управление профилем',
    switchTheme: 'Переключить тему',
    logout: 'Выйти из аккаунта',
    whatsNew: 'Что нового',
    workspaces: 'Воркспейсы',
    requestAccessWorkspaces: 'Нет доступа к воркспейсам проекта',
    requestAccessWorkspacesLabel: 'Запросить',
    addWorkspace: 'Добавить воркспейс',
    favorite: 'Избранное',
    financialMenuTitle: 'Контроль затрат',
    financialMenuToSection: 'К разделу',
    financialMenuEyeButtonDataVisibleTip: 'Скрыть баланс в шапке',
    financialMenuEyeButtonDataHiddenTip: 'Показать баланс в шапке',
    financialMenuBonusSign: 'Б',
    financialMenuTooltipMoreButton: 'Подробнее',
    financialMenuBalanceAction: 'Пополнить баланс',
    financialMenuBonusesAction: 'Ввести промокод',
    financialMenuBonusesDisabledTip: 'Пополните баланс. Чтобы активировать промокод, ваш баланс должен быть положительным.',
    financialMenuGrantInfinity: 'без срока',
    financialMenuNoGrants: 'Грантов пока нет',
    financialMenuGrantStatusSpending: 'Тратится',
    financialMenuGrantStatusNotSpending: 'Не тратится',
    financialMenuGrantStatusNotStart: 'Срок действия пока не наступил',
    financialMenuAddServicesLink: 'Подключить сервисы',
    financialMenuGetGrant: 'Получить стартовый грант',
    financialMenuGrantIsOnTheWay: 'Стартовый грант уже в пути',
    financialMenuStarterGrantName: 'Все сервисы, без GPU',
    project: 'Проект',
    workspace: 'Воркспейс',
    organization: 'Организация',
    searchProjectsPlaceholder: 'Поиск по проектам',
    searchWorkspacesPlaceholder: 'Поиск по воркспейсам',
    themeModeLight: 'Светлая',
    themeModeDark: 'Темная',
    themeModeSystem: 'Системная',
    themeModeLabel: 'Тема интерфейса',
    partnerPopoverTitle: 'Доступна новая организация',
    partnerPopoverText: 'Для нее одобрена заявка на участие в реферальной программе.',
    partnerPopoverDescription: 'Переключитесь на эту организацию, чтобы начать работу в партнерском кабинете. Переключаться между организациями можно в профиле или в меню выбора проекта.',
    partnerPopoverCancelButton: 'Больше не показывать',
    mkpBannerTitle: 'Маркетплейс',
    mkpBannerText: 'Для разработки, анализа данных и других задач.',
    mkpBannerCount: '120+ сервисов',
    referralBannerTitle: 'Реферальная программа',
    referralBannerText: 'Зарабатывайте до 20% на рекомендациях сервисов Cloud.ru',
    referralBannerTag: '20%'
  },
  InfoRow: {
    booleanValueTrue: 'Да',
    booleanValueFalse: 'Нет'
  },
  Layout: {
    noAccessTitle: 'Доступ ограничен',
    noAccessSubtitle: 'У вас нет прав для просмотра этого контента.',
    noAccessText: 'Для получения доступа обратитесь к администратору организации или проекта'
  },
  MobileChips: {
    selectedN: 'Выбрано: ',
    resetAll: 'Сбросить все',
    select: 'Выбрать'
  },
  MobileFields: {
    selectedN: 'Выбрано: ',
    resetAll: 'Сбросить все',
    select: 'Выбрать'
  },
  MobileLayout: {
    "continue": 'Продолжить',
    create: 'Создать',
    save: 'Сохранить',
    cancel: 'Отмена',
    back: 'Назад',
    rent: 'Арендовать',
    send: 'Отправить',
    add: 'Добавить',
    restore: 'Восстановить'
  },
  MobileToaster: {
    closeAll: 'Закрыть все',
    showLess: 'Свернуть',
    showMore: 'Развернуть'
  },
  ModalPredefined: {
    title: 'Удаление',
    recallTitle: 'Отзыв заявки',
    fieldLabel: 'Чтобы разрешить удаление, введите:',
    recallFieldLabel: 'Чтобы отозвать заявку, введите:',
    enterName: 'Введите название',
    required: 'Поле должно быть заполнено',
    invalidName: 'Неверное название',
    cancel: ruTranslations.buttons.cancel,
    "delete": 'Удалить',
    recall: 'Отозвать',
    whatsNew: 'Что нового',
    readLater: 'Ознакомиться позже',
    outOf: 'из',
    noDataTitle: 'Новостей пока нет',
    noDataDescription: 'Скоро здесь появятся новости платформы',
    dataErrorTitle: 'Не удалось получить данные',
    dataErrorDescription: 'Попробуйте перезагрузить страницу',
    dataErrorAction: 'Обновить'
  },
  PageLayout: {
    PageForm: {
      "continue": ruTranslations.buttons["continue"],
      create: ruTranslations.buttons.create,
      save: ruTranslations.buttons.save,
      cancel: ruTranslations.buttons.cancel,
      back: ruTranslations.buttons.back,
      rent: ruTranslations.buttons.rent,
      send: ruTranslations.buttons.send,
      restore: ruTranslations.buttons.restore,
      add: 'Добавить'
    },
    PageSidebar: {
      backTo: 'Назад к',
      documentation: 'Документация',
      searchByServices: 'Поиск по сервисам',
      closeSearch: 'Закрыть поиск',
      openSearch: 'Открыть поиск'
    }
  },
  PriceSummary: {
    total: 'Итого',
    vat: 'с учетом НДС',
    pricePeriodYear: 'в год',
    pricePeriodMonth: 'в месяц',
    pricePeriodDay: 'в день',
    pricePeriodHour: 'в час',
    pricePeriodMinute: 'в минуту',
    price: 'Стоимость',
    basePrice: 'Базовая цена',
    discount: 'Скидка',
    orderDetails: 'Детализация заказа',
    docsLink: 'Подробнее о тарифах и ценах',
    dataError: 'Ошибка загрузки',
    costLink: 'Подробнее о стоимости'
  },
  PromoTagPredefined: {
    preview: 'Preview',
    tooltipService: 'Сервис находится в стадии Preview. Для него недоступно увеличение квоты и не действуют условия тарификации, SLA сервиса и поддержки.',
    tooltipFunctional: 'Функциональность находится в стадии Preview. Для нее не действуют условия тарификации, SLA сервиса и поддержки.'
  },
  Quota: {
    peace: 'шт.',
    created: 'Создано',
    available: 'Доступно по квоте',
    exceeded: 'Квота исчерпана',
    increase: 'Увеличить',
    noData: 'Не удалось загрузить данные',
    quotas: 'Квоты'
  },
  SiteHero: {
    Main: {
      platforms: 'Платформы'
    }
  },
  SiteSection: {
    Basic: {
      showMore: 'Показать еще'
    },
    PersonalManager: {
      title: 'Больше чем просто поддержка',
      subtitle: 'Полное сопровождение для решения ваших задач и понятный бизнес-результат',
      individualApproachTitle: 'Индивидуальный подход к каждому клиенту',
      individualApproachDescription: 'Проведем бесплатную консультацию по вашему проекту, ответим на вопросы и подберем лучшие решения.',
      consultationButton: 'Получить консультацию',
      allDaySupportTitle: 'Круглосуточно на связи',
      allDaySupportDescription: 'Бесплатная техподдержка 24/7, на связи всегда реальные люди.',
      argumentAmountOfExperts: '1 400+ экспертов в области IT, кибербезопасности и AI',
      argumentMethodologies: 'Проверенные методологии и лучшие практики бесшовной миграции в облако',
      argumentPersonalManager: 'Персональный менеджер для сопровождения ваших задач'
    }
  },
  Widget: {
    Solutions: {
      title: 'Руководства для быстрого старта',
      link: 'Смотреть все'
    },
    Products: {
      title: 'Сервисы платформы'
    }
  }
};